import { render, staticRenderFns } from "./v-select.vue?vue&type=template&id=3d2e56e2&scoped=true&"
import script from "./v-select.vue?vue&type=script&lang=ts&"
export * from "./v-select.vue?vue&type=script&lang=ts&"
import style0 from "./v-select.vue?vue&type=style&index=0&id=3d2e56e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e56e2",
  null
  
)

export default component.exports